import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

let uid = 0;

/**
 * A value the inventory cannot supply, so the analyst types it. The amber pill
 * marks the distinction from inventory-sourced fields sitting next to it.
 */
@Component({
  selector: 'ui-manual-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule],
  templateUrl: './ui-manual-input.component.html',
})
export class UiManualInputComponent {
  readonly control = input.required<FormControl<any>>();
  readonly label = input.required<string>();
  readonly type = input<'text' | 'number'>('number');
  readonly placeholder = input('');
  readonly hint = input('');

  readonly id = `ci-manual-${uid++}`;

  readonly invalid = computed(() => {
    const c = this.control();
    return c.invalid && (c.touched || c.dirty);
  });

  readonly errorText = computed(() => {
    const e = this.control().errors ?? {};
    if (e['required']) return `${this.label()} is required.`;
    if (e['positiveNumber']) return `${this.label()} must be greater than zero.`;
    return 'Check this value.';
  });
}
